module.exports = __webpack_public_path__ + "static/media/silhouette.15d1c384.jpg";